import React from "react";
import DriverStoreMappingUpload from "../../components/DriverStoreMappings/BulkUploadMappings";

const DriverStoreMappings = (props) => {
  return <DriverStoreMappingUpload />;
};

export default DriverStoreMappings;
